import { Component, EventEmitter, Output } from '@angular/core'
import {
  FieldBlueprint,
  EMPLOYEE_NEW_JOINEE_UPLOAD_FIELDS_BLUEPRINT,
  EMPLOYEE_NEW_JOINEE_BASIC_INFO_FIELDS_BLUEPRINT,
  EMPLOYEE_NEW_JOINEE_KYC_FIELDS_BLUEPRINT,
  EMPLOYEE_NEW_JOINEE_CONTACT_FIELDS_BLUEPRINT
} from 'src/app/constants/config-blueprint'

@Component({
  selector: 'app-employee-newjoinee-wf-screen-config',
  template: `<app-shared-wf-screen-config
    [SCREEN_TYPE]="SCREEN_TYPE"
    [steps]="steps"
    (completed)="onCompleted()"></app-shared-wf-screen-config>`
})
export class EmployeeNewJoineeWfScreenConfigComponent {
  @Output() completed = new EventEmitter<void>()

  readonly SCREEN_TYPE = 'EMPLOYEE_NEW_JOINEE_WORKFLOW_CONFIG'

  steps: { title: string; blueprint: FieldBlueprint[] }[] = [
    { title: 'Upload Fields', blueprint: EMPLOYEE_NEW_JOINEE_UPLOAD_FIELDS_BLUEPRINT },
    { title: 'Basic Info', blueprint: EMPLOYEE_NEW_JOINEE_BASIC_INFO_FIELDS_BLUEPRINT },
    { title: 'KYC Fields', blueprint: EMPLOYEE_NEW_JOINEE_KYC_FIELDS_BLUEPRINT },
    { title: 'Contact Info', blueprint: EMPLOYEE_NEW_JOINEE_CONTACT_FIELDS_BLUEPRINT }
  ]

  onCompleted() {
    this.completed.emit()
  }
}
